import Refresh from "@mui/icons-material/Refresh";
import { IconButton, LinearProgress } from "@mui/material";
import { Permissions } from "app/constants";
import { ButtonGroup, PageHeader, Toolbar } from "common";
import useAccess from "features/profile/useAccess";
import useSettings from "features/settings/useSettings";
import useHeaderHeight from "helpers/useHeaderHeight";
import I18n from "i18n";
import { usePivotReportDataContext } from "./usePivotReportData";

export interface PivotReportHeaderProps {}

const PivotReportHeader: React.FC<PivotReportHeaderProps> = ({}) => {
  const { load, loading } = usePivotReportDataContext();
  const { hasPermissions } = useAccess();
  const [settings, setSettings] = useSettings({ key: "pivotReport" });
  const headerHeight = useHeaderHeight();

  return (
    <>
      <PageHeader title={I18n.t("PivotReport.title")}>
        <Toolbar sx={{ gap: 2 }}>
          {hasPermissions(Permissions.ReportPrices) && (
            <ButtonGroup
              size="small"
              options={[
                { value: undefined, label: "EUR" },
                { value: "HUF", label: "HUF" },
              ]}
              value={settings.currency}
              onChange={(evt: any) => {
                setSettings({
                  currency: evt.target.value,
                });
              }}
            />
          )}
          <IconButton
            onClick={() => {
              load();
            }}
          >
            <Refresh />
          </IconButton>
        </Toolbar>
      </PageHeader>
      {loading && (
        <LinearProgress
          sx={{ position: "fixed", left: 0, top: headerHeight, right: 0 }}
        />
      )}
    </>
  );
};
export default PivotReportHeader;
